import $ from "jquery";
import { Modal } from "bootstrap";

const modal = new Modal('#fullscreen-menu-modal', {});

$('.js-hamburger').on('click', function () {
  modal.show();
});

$('#fullscreen-menu-modal').on('click', '.js-fullscreen-menu li a', function () {
  modal.hide();
});

// $('.js-hamburger').on('click', function () {
//   /**
//    * Remove focus before opening the modal.
//    * 
//    * Bootstrap modal returns focus to the element that was focused when the modal was opened,
//    * disable this because we have scroll to links in the modal, we want to scroll
//    * to them but return of focus scrolls back to the hamburger.
//    */
//   // $(':focus').trigger('blur'); // doesn't work

//   /**
//    * This method doesn't return focus to the triggering element
//    */
//   modal.show();
// });

// $('.js-fullscreen-menu-modal').on('click', '.js-fullscreen-menu li a', function () {
//   const $link = $(this);

//   console.log('123');
//   $(this).css('background-color', 'red');

//   const modal = Modal.getInstance($link.closest('.js-fullscreen-menu-modal').get(0));
//   if (modal) {
//     modal.hide();
//   }
// });
